import { newRequestKey } from './purchaseIntent';
const PREFIX = 'dmp.v2.application.';
export interface PendingApplication {
  version: 1;
  owner: string;
  product: string;
  key: string;
}
export function pendingApplication(owner: string): PendingApplication | null {
  try {
    const p = JSON.parse(sessionStorage.getItem(PREFIX + owner) || 'null') as PendingApplication | null;
    return p?.version === 1 &&
      p.owner === owner &&
      /^[a-z][a-z0-9_]{0,79}$/.test(p.product) &&
      /^[a-f0-9]{32}$/.test(p.key)
      ? p
      : null;
  } catch {
    return null;
  }
}
export function beginApplication(owner: string, product: string): PendingApplication {
  const p: PendingApplication = { version: 1, owner, product, key: newRequestKey() };
  sessionStorage.setItem(PREFIX + owner, JSON.stringify(p));
  return p;
}
export function finishApplication(owner: string): void {
  sessionStorage.removeItem(PREFIX + owner);
}
export function clearApplications(): void {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k?.startsWith(PREFIX)) sessionStorage.removeItem(k);
    }
  } catch {
    /* 私有申請內容從未寫入瀏覽器儲存。 */
  }
}
